import React from "react";

interface CollaboratorsProps {
}

const collaborators = [
  { name: "Megalabs", logo: "img/megalabs.svg" },
  { name: "Fiat", logo: "img/fiat.svg" },
  { name: "Life Cinemas", logo: "img/lifecinemas.svg" },
  { name: "Rotunda", logo: "img/rotunda.svg" },
  { name: "Hospital Británico", logo: "img/hospitalbritanico.svg" },
  { name: "Inner", logo: "img/inner.svg" },
  { name: "Lady Soft", logo: "img/ladysoft.svg" },
  { name: "Salus", logo: "img/salus.svg" },
  { name: "Fratello", logo: "img/fratello.svg" },
  { name: "Nona", logo: "img/nona.svg" },
  { name: "Apacha", logo: "img/apacha.svg" },
];

export const Collaborators: React.FC<CollaboratorsProps> = (props) => {
  return (
    <div id="collaborators" className="collaborators-section">
      <div className="collaborators-container">
        <div className="collaborators-header">
          <h2 className="collaborators-title">
            Han colaborado con <span className="collaborators-title-highlight">nosotros</span>
          </h2>
        </div>
        <div className="collaborators-grid">
          {collaborators.map((collaborator, index) => (
            <div key={index} className="collaborator-card">
              <div className="collaborator-logo-wrapper">
                <img
                  src={collaborator.logo}
                  alt={collaborator.name}
                  className="collaborator-logo"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};